import { DataTableFacetedFilter } from '@/components/ui/data-table-faceted-filter';
import { managerEventStatuses } from '../../data/event-data';
import { Label } from '@/features/label/components/label';
import { LabelGroup } from '@/features/label/types';
import { useEvents } from '../../api/getEvents';
import { useManagers } from '../../api/getManagers';

interface LocationFiltersProps {
  table: any;
}

export function ManagerFilters({ table }: LocationFiltersProps) {
  const { data: events = [] } = useEvents({
    assignedToMe: false,
  });

  const { data: _managers = [] } = useManagers({});

  const organizers = [...new Set(events.map((event) => event.organizerName))];
  const managers = _managers.reduce((acc: any, event) => {
    if (!acc.some((manager: any) => manager.value === event.managerId)) {
      acc.push({ value: event.managerId, label: event.username });
    }
    return acc;
  }, []);

  return (
    <div className="flex gap-2 overflow-x-auto">
      <DataTableFacetedFilter
        column={table.getColumn('status')}
        TitleComponent={<Label name="status" groupName={LabelGroup.MANAGER_EVENT_LIST} />}
        options={managerEventStatuses}
      />
      {/* <DataTableFacetedFilter
        column={table.getColumn('category')}
        TitleComponent={<Label name="categories" groupName={LabelGroup.MANAGER_EVENT_LIST} />}
        options={categories}
      /> */}
      <DataTableFacetedFilter
        column={table.getColumn('organizerName')}
        TitleComponent={<Label name="organizer" groupName={LabelGroup.MANAGER_EVENT_LIST} />}
        options={
          organizers?.map((organizer) => ({
            value: organizer,
            label: organizer,
          })) || []
        }
      />
      <DataTableFacetedFilter
        column={table.getColumn('assignedUserId')}
        TitleComponent={<Label name="managers" groupName={LabelGroup.MANAGER_EVENT_LIST} />}
        options={managers}
      />
    </div>
  );
}
